import { useContext, useEffect, useState } from "react";
import {
  FormControl,
  LinearProgress,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";

import LinearProgressBar from "../components/Graph/LinearProgress";
import DashboardService from "../services/api";
import { DashboardtopContainer } from "../components/Container/DashboardtopContainer";
import PieChartGraph from "../components/Graph/PieChartGraph";
import WeeklyBarChart from "../components/Graph/WeeklyBarChart";
import { AssessmentContainer } from "../components/Container/AssessmentContainer";
import { WorkshopCardContainer } from "../components/Container/WorkshopCardContainer";
import { appContext } from "../Context/AppContext";
import { DateTime } from "luxon";

export const Dashboard = () => {
  const { department, location ,fromDate ,toDate, monthValue } = useContext(appContext);
  const localData = localStorage.getItem("userdata") ||JSON.stringify({accessCode:""}) ;
  const access_code = JSON.parse(localData).accessCode ;
  const [bookingWeekData, setBookingWeekData] = useState<any>(null);
  const [workshopData, setWorkshopData] = useState({
    joined_users: 0,
    joining_percentage: 0,
    total_workshop: 0,
  });
  const [blogs, setBlogs] = useState<any>([]);
  const [modules, setModules] = useState<any>([]);
  const [userData, setUserData] = useState<any>({ total: 0, engaging: 0, monthlyUsers :0, monthlyEngagingUsers:0 });
  const [bookingData, setBookingData] = useState<any>({
    completed: 0,
    totalBookings: 0,
    upcoming: 0,
  });
  const [resources, setResources] = useState<any>({
    blogCount: 0,
    selfCareCount: 0,
  });
  const [activityData, setActivityData] = useState<any>({
    userTakingAssessments: 0,
    usersEngagingWithChatBot: 0,
    usersTakingSessions: 0,
  });
  const [assessment, setAssessment] = useState<any>([]);

  function calculatePercentage(number: any, total: any): number {
    if (total === 0) {
      return  0
    }

    return Math.round((number / total) * 100);
  }

  const calculateAddPercentage = (total: any, data: any) => {
    const result = [];


    for (const item of data) {
      const percentage = Math.round((item.count / total) * 100);
      result.push({ name: item._id, percentage });
    }

    return result;
  };

  function getMonthName(dateString: string) {
    const date = DateTime.fromISO(dateString);
    return date.toFormat("MMMM");
  }

  const fetchData = async () => {
    DashboardService.getDashboardData(access_code,department,location,fromDate,toDate)
      .then((res: any) => {
        const data = res.data;
        const { blogCount, blogs, modules, selfCareCount } = data.resouces;
        setUserData({
          total: data.userData.totalUsers,
          engaging: data.userData.totalEngagingUsers,
          monthlyUsers:data.userData.usersInRange,
          monthlyEngagingUsers:data.userData.engagingUsersInRange,
        });
        setBookingData({
          completed: data.bookings.completed,
          totalBookings: data.bookings.totalBookings,
          upcoming: data.bookings.upcoming,
        });
        setAssessment(data.assessment);
        setBookingWeekData(data.bookings.fourWeekData);
        setActivityData({ ...data.activity });
        setResources({ blogCount, selfCareCount });
        setBlogs(calculateAddPercentage(data.userData.totalUsers, blogs));
        setModules(calculateAddPercentage(data.userData.totalUsers, modules));
        setWorkshopData(data.workshopData);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  useEffect(() => {
    fetchData();
  }, [department,location,fromDate]);
  return (
    <div style={{ padding: "20px" }}>
      <h1>Welcome to your dashboard!</h1>
      <p>Here’s the overview of your organisation’s emotional wellbeing</p>
      {bookingWeekData && (
        <div className={assessment.length>1?"assessment-container":"two-div-container"}>
          <DashboardtopContainer
            onboarded={userData.total}
            engaging={userData.engaging}
            monthlyengagingusers={userData.monthlyEngagingUsers}
            monthlyusers={userData.monthlyUsers}
            monthValue={monthValue}
          />
          {assessment.length>1?
          <>
            <AssessmentContainer  monthValue={monthValue} {...assessment[0]} />
          <AssessmentContainer monthValue={monthValue}  {...assessment[1]} />
          </> : <WorkshopCardContainer data={workshopData} monthValue={monthValue}/>}
        </div>
      )}

      {bookingWeekData && (
        <div style={{ padding: "0 15px", backgroundColor: "#fff" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "15px 0",
            }}
          >
            <div style={{ fontSize: "20px" }}>Consultation</div>
          </div>
          <div style={{ display: "flex", marginBottom: "20px" }}>
            <div
              style={{
                flex: 1.75,
                borderTop: "1px solid #eeeff2",
                borderRight: "1px solid #eeeff2",
              }}
            >
              <div style={{ padding: "15px" }}>
                <div style={{ padding: "15px 0 20px 0" }}>
                  No. of upcoming sessions
                </div>
                <div>
                  <div>
                    <LinearProgressBar
                      progress={bookingData.upcoming}
                      total={bookingData.totalBookings}
                      color={"#3baff6"}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginRight: "60px",
                      fontSize: "14px",
                      color: "#a7aaad",
                    }}
                  >
                    <div>0</div>
                    <div>{bookingData.totalBookings}</div>
                  </div>
                </div>
              </div>
              <div style={{ padding: "15px" }}>
                <div style={{ padding: "30px 0 20px 0" }}>
                  Total no. of sessions successfully completed  
                </div>
                <div>
                  <div>
                    <LinearProgressBar
                      progress={bookingData.completed}
                      total={bookingData.totalBookings}
                      color={"#4a51a7"}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginRight: "60px",
                      fontSize: "14px",
                      color: "#a7aaad",
                    }}
                  >
                    <div>0</div>
                    <div>{bookingData.totalBookings}</div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                flex: 3,
                padding: "10px",
                borderTop: "1px solid #eeeff2",
              }}
            >
              <div style={{ padding: " 0 0 40px 40px" }}>
                No. of sessions booked over last 4 week
              </div>
              <div>
                <WeeklyBarChart data={bookingWeekData} disabled={monthValue?true:false} />
              </div>
            </div>
          </div>
        </div>
      )}
      {bookingWeekData && (
        <div style={{ padding: "0 15px", backgroundColor: "#fff" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "15px 0",
            }}
          >
            <div style={{ fontSize: "20px" }}>Consultation</div>
          </div>
          <div className="card-container">
            <div
              style={{
                flex: 1.75,
                borderTop: "1px solid #eeeff2",
                borderRight: "1px solid #eeeff2",
              }}
            >
              <div style={{ padding: "15px" }}>
                <div style={{ padding: "10px 0 0 0" }}>
                  No. of {access_code? "employees":"users"} taking sessions
                </div>
                <div style={{ marginLeft: "-18px" }}>
                  <TableRow>
                    <TableCell sx={{ width: "400px", borderBottom: "none" }}>
                      <LinearProgress
                        variant="determinate"
                        value={calculatePercentage(
                          activityData.usersTakingSessions,
                          userData.total
                        )}
                        sx={{
                          width: "100%",
                          height: "40px",
                          borderRadius: "0 5px 5px 0",
                          backgroundColor: "#f7f7f7",
                          "& .MuiLinearProgress-bar1Determinate": {
                            backgroundColor: `#3baff6`,
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell
                      style={{
                        borderBottom: "none",
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                    >
                      {calculatePercentage(
                        activityData.usersTakingSessions,
                        userData.total
                      )}
                      %
                    </TableCell>
                  </TableRow>
                </div>
              </div>
              <div style={{ padding: "15px" }}>
                <div style={{ padding: "10px 0 0 0" }}>
                  No. of {access_code? "employees":"users"} engaging with chat bot
                </div>
                <div style={{ marginLeft: "-18px" }}>
                  <TableRow>
                    <TableCell sx={{ width: "400px", borderBottom: "none" }}>
                      <LinearProgress
                        variant="determinate"
                        value={calculatePercentage(
                          activityData.usersEngagingWithChatBot,
                          userData.total
                        )}
                        sx={{
                          width: "100%",
                          height: "40px",
                          borderRadius: "0 5px 5px 0",
                          backgroundColor: "#f7f7f7",
                          "& .MuiLinearProgress-bar1Determinate": {
                            backgroundColor: `#3baff6`,
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell
                      style={{
                        borderBottom: "none",
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                    >
                      {calculatePercentage(
                        activityData.usersEngagingWithChatBot,
                        userData.total
                      )}
                      %
                    </TableCell>
                  </TableRow>
                </div>
              </div>
              <div style={{ padding: "15px" }}>
                <div style={{ padding: "10px 0 0 0" }}>
                  No. of {access_code? "employees":"users"} taking assessments
                </div>
                <div style={{ marginLeft: "-18px" }}>
                  <TableRow>
                    <TableCell sx={{ width: "400px", borderBottom: "none" }}>
                      <LinearProgress
                        variant="determinate"
                        value={calculatePercentage(
                          activityData.userTakingAssessments,
                          userData.total
                        )}
                        sx={{
                          width: "100%",
                          height: "40px",
                          borderRadius: "0 5px 5px 0",
                          backgroundColor: "#f7f7f7",
                          "& .MuiLinearProgress-bar1Determinate": {
                            backgroundColor: `#3baff6`,
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell
                      style={{
                        borderBottom: "none",
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                    >
                      {calculatePercentage(
                        activityData.userTakingAssessments,
                        userData.total
                      )}
                      %
                    </TableCell>
                  </TableRow>
                </div>
              </div>
            </div>
            <div
              style={{
                flex: 3,
                padding: "10px",
                borderTop: "1px solid #eeeff2",
              }}
            >
              <div style={{ paddingLeft: "30px" }}>
                No. of sessions booked over {monthValue?`${getMonthName(monthValue)} month`:"time"}
              </div>
              <div>
                <PieChartGraph obj={activityData}  />
              </div>
            </div>
          </div>
        </div>
      )}
      {bookingWeekData && (
        <div className="card-container">
          <div
            style={{
              backgroundColor: "#fff",
              marginRight: "20px",
              paddingBottom: "35px",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                padding: "15px",
                borderBottom: "1px solid #eeeff2",
              }}
            >
              Activities
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "15px",
                marginTop: "15px",
              }}
            >
              <div>No. of {access_code? "employees":"users"} engaging with activities</div>
              <div style={{ fontSize: "24px" }}>{resources.selfCareCount}</div>
            </div>
            <div style={{ height: "200px" }}>
              <TableContainer>
                <Table>
                  <TableBody>
                    {modules.map((row: any, index: any) => (
                      <TableRow key={index}>
                        <TableCell
                          sx={{ fontWeight: "500", borderBottom: "none" }}
                        >
                          {row.name}
                        </TableCell>
                        <TableCell
                          sx={{ width: "300px", borderBottom: "none" }}
                        >
                          <LinearProgress
                            variant="determinate"
                            value={row.percentage}
                            sx={{
                              width: "100%",
                              height: "15px",
                              borderRadius: "0 5px 5px 0",
                              backgroundColor: "#f7f7f7",
                              "& .MuiLinearProgress-bar1Determinate": {
                                backgroundColor: `#3baff6`,
                              },
                            }}
                          />
                        </TableCell>
                        <TableCell style={{ borderBottom: "none" }}>
                          {row.percentage}%
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
          <div
            style={{
              backgroundColor: "#fff",
              marginRight: "20px",
              paddingBottom: "35px",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                padding: "15px",
                borderBottom: "1px solid #eeeff2",
              }}
            >
              Resources
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "15px",
                marginTop: "15px",
              }}
            >
              <div>No. of {access_code? "employees":"users"} reading the blogs</div>
              <div style={{ fontSize: "24px" }}>{resources.blogCount}</div>
            </div>

            <div style={{ height: "200px" }}>
              <TableContainer>
                <Table>
                  <TableBody>
                    {blogs.map((row: any, index: any) => (
                      <TableRow key={index}>
                        <TableCell
                          sx={{ fontWeight: "500", borderBottom: "none" }}
                        >
                          {row.name}
                        </TableCell>
                        <TableCell
                          sx={{ width: "300px", borderBottom: "none" }}
                        >
                          <LinearProgress
                            variant="determinate"
                            value={row.percentage}
                            sx={{
                              width: "100%",
                              height: "15px",
                              borderRadius: "0 5px 5px 0",
                              backgroundColor: "#f7f7f7",
                              "& .MuiLinearProgress-bar1Determinate": {
                                backgroundColor: `#3baff6`,
                              },
                            }}
                          />
                        </TableCell>
                        <TableCell style={{ borderBottom: "none" }}>
                          {row.percentage}%
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
